export default {
  methods: {
    // 路由跳转
    jump: function (to, query, isReplace) {
      const isGo = ['-1', '0', '1'].includes(`${to}`);
      if (isGo) {
        this.$router.go(to);
        return;
      }
      if (typeof query === 'boolean') {
        isReplace = query;
        query = {};
      }
      if (isReplace) {
        this.$router.replace({ path: to, query: query || {} });
        return;
      }
      this.$router.push({ path: to, query: query || {} });
    },
    // 获取路由信息
    getJump: function (name, value) {
      value = typeof value === 'undefined' ? '' : value;
      return this.$route.query[name] || value;
    },
    // 设置或更改state
    setState: function (name, value) {
      this.$store.commit(name, value); // mutation方法
      // action方法：this.$store.dispatch(name,value)
    },
    // 获取Vuex信息
    getState: function (name) {
      return this.$store.state[name];
    },
    // 联系客服
    customerService: function (tel) {
      if (!tel) return;
      window.location.href = `tel:${tel}`;
    },
  },
  beforeDestroy: function () {
    this.$store.commit('REFRESH', true);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/index.js